import * as React from 'react'

import { Box, DoubleRangeSlider, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  value: [number | null | undefined, number | null | undefined]
  onChange: (value: [number, number]) => void
  disabled: boolean
  range: [number, number]
}

const RangeInput = (props: Props) => {
  const {
    value: [min, max],
    onChange,
    disabled,
    range: [rangeMin, rangeMax],
  } = props

  const value = [
    min === null || min === undefined ? rangeMin : min,
    max === null || max === undefined ? rangeMax : max,
  ]

  return (
    <Box gap="s8" paddingBottom="s24">
      <Text.Normal size="200" weight="medium" color="grey800">
        {i18n.t('settings.custom_fields.new.labels.rating_range')}
      </Text.Normal>
      <DoubleRangeSlider
        min={rangeMin}
        max={rangeMax}
        value={value as any}
        onChange={onChange}
        readonly={disabled}
      />
    </Box>
  )
}

export default RangeInput
